import { API_BASE_URL } from '../globals';
import { POST, GET } from '@api/apiHandler';
import { LOGOUT } from './routes';

export const logout = async () => {
    return POST(`${API_BASE_URL}${LOGOUT}`, {});
  };